/*
Replace
allergen with your resource Name :) Take care about different writings!
/!\ Allergen allergen Allergens allergens /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const allergenSlice = createSlice({
  name: "allergens",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listAllergens,
  show: showAllergen,
  create: createAllergen,
  update: updateAllergen,
} = allergenSlice.actions;

export const actions = allergenSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const allergens = (state) =>
  state.allergens.idsList.map((id) => state.allergens.dictionary[id]);
export const allergen = (state) =>
  state.allergens.showId && state.allergens.dictionary[state.allergens.showId];
export const allergenAttributes = (state) => allergen(state)?.attributes;
export const allergenRelationships = (state) => allergen(state)?.relationships;
export const allergenId = (state) => state.allergens.showId;

export const getAllergen = createSelector(
  (state) => state.allergens.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getAllergenAttributes = createSelector(
  (state) => state.allergens.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getAllergenRelationships = createSelector(
  (state) => state.allergens.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getAllergens = createSelector(
  (state) => state.allergens.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default allergenSlice.reducer;
